<template lang="pug">
div
  v-card.round-xl.pa-4(outlined)
    div.d-flex.align-center
      .text-xs.neutral500--text.font-semibold Offers
      v-spacer
      y-button(v-if="!hideViewAll" label="View all" outlined color="neutral400" text-color="neutral700" size="xxs" unset-min-width button-class="px-2" @click="handleViewAll")
    template(v-if="coupons.isFetching")
      v-skeleton-loader(type="list-item-two-line")
    template(v-else)
      .text-xs.neutral500--text(v-if="!coupons.data.length") No available offers
      v-row.mt-1(v-else)
        template(v-for="(coupon, idx) in coupons.data")
          v-col(cols="6" :class="[{ 'pr-2': idx === 0 }, { 'pl-2': idx === 1 }]" :key="`cpn-${idx}`")
            offers-card-items(:title="coupon.offer.name" :subtitle="coupon.code" @apply="handleViewOne(idx)")

    .dialogs
      redeem-offer-dialog(v-if="redeemOffers.open" :open.sync="redeemOffers.open" :customer="customer" :lead-id="leadId" :disabled="disabled" :disable-text="disableText" @updated="handleUpdated")
      redeem-one-offer-dialog(v-if="redeemOneOffer.open" :open.sync="redeemOneOffer.open" :offer="redeemOneOffer.data" :customer="customer" :lead-id="leadId" @updated="handleUpdated")
</template>

<script>
import {mapActions, mapGetters} from "vuex";
import OffersCardItems from "@/components/clinic/checkout/marketing/OffersCardItems.vue";
import RedeemOfferDialog from "@/components/clinic/checkout/marketing/redeem/offer/RedeemOfferDialog.vue";
import RedeemOneOfferDialog from "@/components/clinic/checkout/marketing/redeem/offer/RedeemOneOfferDialog.vue";

export default {
  components: {
    RedeemOneOfferDialog,
    RedeemOfferDialog,
    OffersCardItems
  },
  props: {
    patient: {
      type: Object,
      default: null
    },
    disabled: {
      type: Boolean,
      default: false
    },
    disableText: {
      type: String,
      default: null
    },
  },
  data () {
    return {
      isFetchingInvoice: false,
      coupons: {
        isFetching: true,
        data: [],
      },
      redeemOffers: {
        open: false,
      },
      redeemOneOffer: {
        open: false,
        data: null
      },
    }
  },
  mounted () {
    this.fetchOffers()
  },
  computed: {
    ...mapGetters({
      company: 'getCompany',
      leadPid: 'treatment/getLeadPid',
      invoice: 'treatment/getInvoice',
      vuexPatient: 'treatment/getPatient',
    }),
    customer () { 
      if (this.patient && this.patient.id) {
        return {
          id: this.patient.id || null,
          name: this.patient.name || null,
          phone: this.patient.phone || null,
          ic: this.patient.ic || null,
          dob: this.patient.dob || null,
          address: this.patient.address || null,
          profile_image: this.patient.profile_image || null,
        }
      }
      return this.vuexPatient
    },
    leadId () {
      return this.invoice.lead
    },
    hideViewAll() {
      return this.coupons.isFetching || this.coupons.data.length === 0
    }
  },
  methods: {
    ...mapActions(['showMessage']),
    async fetchOffers() {
      const url = `/marketing/${this.company.slug}/coupons`
      const params = {
        customer: this.customer.id,
        ordering: 'expired_at',
        page_size: 2,
      }
      try {
        this.coupons.isFetching = true
        const {data} = await this.$axios.get(url, {params})
        this.coupons.data = data.results
      } catch (error) {
        this.showMessage(['error', this.$t('error_message.unable_to_complete_request')])
      } finally {
        this.coupons.isFetching = false
      }
    },
    fetchInvoice () {
      this.isFetchingInvoice = true
      this.$axios.get(`/invoices/${this.leadPid}`)
        .then(resp => {
          this.$store.commit('treatment/setInvoice', resp.data)
        })
        .catch(() => {})
        .finally(() => {
          this.isFetchingInvoice = false
        })
    },
    handleViewAll() {
      // if (this.disabled) {
      //   this.showMessage(['error', this.disableText || 'You cannot redeem offers at the moment.'])
      //   return
      // }
      this.redeemOffers.open = true
    },
    handleViewOne(itemIndex) {
      if (this.disabled) {
        this.showMessage(['error', this.disableText || 'You cannot redeem offers at the moment.'])
        return
      }
      this.redeemOneOffer.data = this.coupons.data[itemIndex]
      this.redeemOneOffer.open = true
    },
    handleUpdated() {
      this.fetchOffers()
      this.fetchInvoice()
    }
  },
}
</script>

<style scoped>
.border-gray {
  border-color: #c1c1c1;
}
</style>